import constants from './constants.js';

export default {
    isNull,
    isEmpty,
    isEmptyArray,
    isNullEmpty,
    isNullEmptyArray,
    isNullEmptyBlank,
    isNumberNaN,
    isStringMatch,
    checkLengthOfAuthenticationCode,
    checkLengthOfCompanyId,
    checkLengthOfUserId,
    checkLengthOfPassword,
    checkLengthOfMailAddress,
    checkLengthOfTelNumber,
    checkLengthOfShortString,
    checkLengthOfString,
    checkLengthOfLongString,
    isMatchPatternNumber,
    isMatchPatternAlphabetNumber,
    isMatchPatternLowerAlphabetNumber,
    isMatchPatternAlphabetNumberMix,
    isMatchPatternAlphabetNumberSymbol,
    isMatchPatternTelNumber,
    isMatchPatternMailAddress,
    isMatchPatternKana,
    encodeStringToUriComponent,
    removeTimeDataFromDate,
    checkLengthOfKeyword,
    checkLengthOfManagementLongNameString,
    checkLengthOfManagementShortNameString,
    checkLengthOfDisplayOrderNumber,
    isMatchPatternAlphabetNumberSymbolForManagementNameEn,
    isMatchPatternAlphabetNumberSymbolForManagementId,
    isMatchIpAddress,
    changeNullValueToEmpty,
    checkLengthOfSettingCurrentString,
    checkLengthOfSettingMailAddressString,
    changeValueToNumberOrNull,
};

/**
 * 引数の対象が、null、または、undefined、かどうかを判定する。
 *
 * @param {*} trg
 * @returns {Boolean}
 */
function isNull(trg) {
    return trg === null || trg === undefined ? true : false;
}

/**
 * 引数の対象が、空、かどうかを判定する。
 *
 * @param {String} trg
 * @returns {Boolean}
 */
function isEmpty(trg) {
    return trg === '' ? true : false;
}

/**
 * 引数の対象の長さが0どうかを判定する。
 *
 * @param {Array} trg
 * @returns {Boolean}
 */
function isEmptyArray(trg) {
    return trg.length === 0 ? true : false;
}

/**
 * 引数の対象が、null、または、undefined、または、空、かどうかを判定する。
 *
 * @param {*} trg
 * @returns {Boolean}
 */
function isNullEmpty(trg) {
    return trg === null || trg === undefined || trg === '' ? true : false;
}

/**
 * 引数の対象が、null、または、undefined、または、対象の長さが0どうかを判定する。
 *
 * @param {Array} trg
 * @returns {Boolean}
 */
function isNullEmptyArray(trg) {
    return trg === null || trg === undefined || trg.length === 0 ? true : false;
}

/**
 * 引数の対象が、null、または、undefined、または、空、または、空白が入っているかどうかを判定する。
 *
 * @param {*} trg
 * @returns {Boolean}
 */
function isNullEmptyBlank(trg) {
    return trg === null || trg === undefined || trg === '' || trg === ' ' ? true : false;
}

/**
 * 引数の対象を数値型に変えて、数値型に変換できなかった場合は、NaNになるので、isNaNクラスを使って、数値型に変換出来たか出来なかったかを判定する。
 * @param {*} trg
 * @returns {Boolean}
 */
function isNumberNaN(trg) {
    return isNaN(Number(trg));
}

/**
 * 引数1と引数2の文字列が一致しているかどうかを判定する。
 * @param {String} trg1
 * @param {String} trg2
 * @returns {Boolean}
 */
function isStringMatch(trg1, trg2) {
    return trg1 === trg2 ? true : false;
}

/**
 * 文字数の制限条件に一致する場合は「true」を返却する。
 * 文字数の制限条件に一致しない場合は「false」を返却する。
 *
 * @param {*} trg
 * @returns {Boolean}
 */
// 認証コード
function checkLengthOfAuthenticationCode(trg) {
    return trg.length > constants.maxLengthOfAuthenticationCode ? true : false;
}
// 企業ID
function checkLengthOfCompanyId(trg) {
    return trg.length > constants.maxLengthOfCompanyId ? true : false;
}
// ユーザーID
function checkLengthOfUserId(trg) {
    return trg.length > constants.maxLengthOfUserId ? true : false;
}
// パスワード・家族/企業パスワード
function checkLengthOfPassword(trg) {
    return trg.length < constants.minLengthOfPassword || trg.length > constants.maxLengthOfPassword ? true : false;
}
// メールアドレス
function checkLengthOfMailAddress(trg) {
    return trg.length > constants.maxLengthOfMailAddress ? true : false;
}
// 電話番号
function checkLengthOfTelNumber(trg) {
    return trg.length > constants.maxLengthOfTelNumber ? true : false;
}
// 短文文字列。姓・名・続柄など
function checkLengthOfShortString(trg) {
    return trg.length > constants.maxLengthOfShortString ? true : false;
}
// 文字列。問診・アンケート項目など
function checkLengthOfString(trg) {
    return trg.length > constants.maxLengthOfString ? true : false;
}
// 長文文字列。連絡メッセージなど
function checkLengthOfLongString(trg) {
    return trg.length > constants.maxLengthOfLongString ? true : false;
}
// キーワード
function checkLengthOfKeyword(trg) {
    return trg.length > constants.maxLengthOfKeywordString ? true : false;
}
// 管理名など（組織マスタ、勤務地マスタ用）
function checkLengthOfManagementLongNameString(trg) {
    return trg.length > constants.maxLengthOfManagementLongNameString ? true : false;
}
// 管理名など（組織マスタ・勤務地マスタ以外の属性マスタ用。例：職種マスタや時間外労働時間マスタなど）
function checkLengthOfManagementShortNameString(trg) {
    return trg.length > constants.maxLengthOfManagementShortNameString ? true : false;
}
// 表示順
function checkLengthOfDisplayOrderNumber(trg) {
    return trg < constants.minLengthOfDisplayOrderString || trg > constants.maxLengthOfDisplayOrderNumber ? true : false;
}
// 連絡先設定画面の部署や、氏名、電話番号の文字数のチェック関数
function checkLengthOfSettingCurrentString(trg) {
    return trg.length > constants.maxLengthOfSettingCurrentString ? true : false;
}
// 連絡先設定画面のメールアドレスの文字数のチェック関数
function checkLengthOfSettingMailAddressString(trg) {
    return trg.length > constants.maxLengthOfSettingMailAddressString ? true : false;
}
/**
 * パターンに一致する場合は「true」を返却する。
 * パターンに一致しない場合は「false」を返却する。
 *
 * @param {*} trg
 * @returns {Boolean}
 */
// 0-9の数字のみ許容する。（認証コード）
function isMatchPatternNumber(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternNumber);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 半角英数字のみ許容する。（企業ID、ユーザーキー）
function isMatchPatternAlphabetNumber(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternAlphabetNumber);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 半角英数小文字のみ許容する。（ユーザーID）
function isMatchPatternLowerAlphabetNumber(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternLowerAlphabetNumber);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 半角英数混合のみ許容する。（家族/企業パスワード）
function isMatchPatternAlphabetNumberMix(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternAlphabetNumberMix);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 半角英数記号混合のみ許容する。（パスワード）
function isMatchPatternAlphabetNumberSymbol(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternAlphabetNumberSymbolMix);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 半角数字＋「-(ハイフン)」のみ許容する。（電話番号）
function isMatchPatternTelNumber(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternTelNumber);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// メールアドレスのみ許容する。
function isMatchPatternMailAddress(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternMailAddress);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 全角カナ＋全角英数字＋全角記号のみ許容する。（姓（セイ）・名（メイ））
//function isMatchPatternKana(trg) {
function isMatchPatternKana() {
    /*
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternKana);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
    */
    return true;
}

/**
 * 文字列をURLエンコードする。
 * @param {String} trg URLエンコード前の文字列。
 * @returns {String} URLエンコード後の文字列。
 */
function encodeStringToUriComponent(trg) {
    return encodeURIComponent(trg);
}

/**
 * APIの日時情報の返却値から、画面描画時に時間情報を除外して、日付情報のみにしたい場合のメソッド。
 * @param {String} trg 日時の文字列。
 * @returns {String} 時間情報を除外した日付のみの文字列。
 */
function removeTimeDataFromDate(trg) {
    return trg.split(' ')[0]; // 加工例：「2000/01/01 10:00:00」の場合、中央の半角スペースを基準に分割して、前方部分を返却する。
}

// 各属性マスタの英語名称の入力欄は、半角英数と指定された記号のみ許容する。
function isMatchPatternAlphabetNumberSymbolForManagementNameEn(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternManagementNameEn);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// 各属性マスタのID項目の入力欄は、半角英数と指定された記号のみ許容する。
function isMatchPatternAlphabetNumberSymbolForManagementId(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchPatternManagementId);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// IPアドレス＋区切り文字のみ許容する。
function isMatchIpAddress(trg) {
    // 文字列で保管されている正規表現ルールを、「RegExp」で正規表現として解釈させる。
    const matchPattern = new RegExp(constants.matchIpAddress);
    // 入力内容の正規表現チェックでエラーがある場合はnullが返る。
    // 本システムのisNull関数を実行して判定する。
    return isNull(trg.match(matchPattern)) ? false : true;
}

// APIから取得したデータや、画面上の初期値などで、null要素の場合、画面制御上の理由で、空文字に変更する。
function changeNullValueToEmpty(trg) {
    if (!isNull(trg)) {
        return trg;
    } else {
        return '';
    }
}

// APIから取得したデータや、画面上の初期値などで、空文字、もしくは、何かしらの文字列も存在しない場合はnullに変更する。
function changeValueToNumberOrNull(trg) {
    return isNullEmpty(trg) ? null : isNumberNaN(trg) ? null : Number(trg);
}
